import React from 'react';
import { Card, Row } from 'react-bootstrap';
import { getCurrentStyle } from '../../../helpers/passport';

export default function ContentsNew({ data, acceptedData }) {
  return (
    <div className="read-only">
      <Card className="mb-4">
        <Card.Header as={Card.Title} className="p-4">Содержание</Card.Header>
        <Card.Body className="p-4">
          {data.strategy.type === 'tech' && (
            <Row className="mb-4">
              <Card.Subtitle className="mb-2 text-muted">Влияние проекта на цели и задачи СТП</Card.Subtitle>
              <Card.Text style={{ ...getCurrentStyle(data.status, data, acceptedData, 'influenceOnTechDescr'), ...{ whiteSpace: 'pre-wrap' } }}>{data.influenceOnTechDescr || '-'}</Card.Text>
            </Row>
          )}
          {data.strategy.type === 'goal' && (
            <Row className="mb-4">
              <Card.Subtitle className="mb-2 text-muted">Влияние проекта на стратегическую цель развития (главную)</Card.Subtitle>
              <Card.Text style={{ ...getCurrentStyle(data.status, data, acceptedData, 'influenceOnGoalDescr'), ...{ whiteSpace: 'pre-wrap' } }}>{data.influenceOnGoalDescr || '-'}</Card.Text>
            </Row>
          )}
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Цель или решаемая проблема</Card.Subtitle>
            <Card.Text style={{ ...getCurrentStyle(data.status, data, acceptedData, 'goal'), ...{ whiteSpace: 'pre-wrap' } }}>{data.goal || '-'}</Card.Text>
          </Row>
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Предлагаемое решение</Card.Subtitle>
            <Card.Text style={{ ...getCurrentStyle(data.status, data, acceptedData, 'solution'), ...{ whiteSpace: 'pre-wrap' } }}>{data.solution || '-'}</Card.Text>
          </Row>
          <Row>
            <Card.Subtitle className="mb-2 text-muted">Описание способа реализации проекта</Card.Subtitle>
            <Card.Text style={{ ...getCurrentStyle(data.status, data, acceptedData, 'descr'), ...{ whiteSpace: 'pre-wrap' } }}>{data.descr || '-'}</Card.Text>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}
